export default "__VITE_ASSET__C02G1d$l__"